import PropTypes from 'prop-types';
import React from 'react';
import classnames from 'classnames';
import { t } from 'services/translation';

import './index.scss';

export default class Checkbox extends React.Component {
  static displayName = 'Checkbox';

  static propTypes = {
    name: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    value: PropTypes.bool,
    label: PropTypes.string,
    theme: PropTypes.string,
    errors: PropTypes.array,
  };

  static defaultProps = {
    value: false,
    label: '',
    theme: 'Default',
    errors: [],
  };

  onChangeProxy(e) {
    this.props.onChange(this.props.name, !this.props.value, e);
  }

  _hasError() {
    return this.props.errors.length > 0;
  }

  render() {
    const inputWrapperClasses = classnames(
      'Checkbox',
      'ui',
      'input',
      `t-${this.props.theme}`,
      {
        error: this._hasError(),
      }
    );

    const indicatorClasses = classnames('Checkbox-indicator-fill', {
      'af-checkmark brand-bg': this.props.value,
    });
    const { register, name, value } = this.props;
    return (
      <div className={inputWrapperClasses} data-testid="check">
        <div className="Checkbox-input-content">
          <input
            name={name}
            type="checkbox"
            value={value}
            style={{ display: 'none' }}
            {...(register && register(name))}
          />
          <div
            data-testid={
              this.props.dataTestProp
                ? this.props.dataTestProp
                : 'checkbox-input'
            }
            className="Checkbox-indicator-container"
            onClick={this.onChangeProxy.bind(this)}
          >
            <span
              className="Checkbox-indicator"
              data-testid="experience-filter-checkbox"
            >
              <span className={indicatorClasses} />
            </span>
          </div>
          <div className="Checkbox-label">
            {this.props.label}
            <span
              className="popup-link"
              data-testid="popup-link"
              onClick={this.props.linkClick}
            >
              {this.props.children}
            </span>
          </div>
        </div>
        {this._hasError() ? (
          <span className="input-error">{this.props.errors[0] || ''}</span>
        ) : null}
      </div>
    );
  }
}
